import { mergePatch } from "./utils/merge-patch.js";
export class DefaultConfigurationModel {
    data = {};
    getRawData() {
        return this.data;
    }
    setRawData(data) {
        this.data = data;
    }
    patchRawData(patch) {
        this.setRawData(mergePatch(this.getRawData(), patch));
    }
    serializeModelToApiJsonObject(otherData) {
        return {
            ...otherData,
            configuration: this.getRawData()
        };
    }
}
/**
 * Factory method that creates the configuration model.
 */
export function createDefaultConfigurationModelFromJsonObject(data) {
    const model = new DefaultConfigurationModel();
    model.setRawData(data?.["configuration"] ?? {});
    return model;
}
//# sourceMappingURL=model.js.map